import FetchServices from "./FetchServices";
import apiService from "./ApiServices";
import useConfig from "../hooks/useConfig";
import axios from "axios";
import employeeIcon from "../assets/images/empIcon.svg";
import role_employeeIcon1 from "../assets/images/employeesIcons/role_1.svg";
import role_employeeIcon2 from "../assets/images/employeesIcons/role_2.svg";
import role_employeeIcon3 from "../assets/images/employeesIcons/role_3.svg";
import role_employeeIcon4 from "../assets/images/employeesIcons/role_4.svg";
import role_employeeIcon5 from "../assets/images/employeesIcons/role_5.svg";
import security_employeeIcon1 from "../assets/images/employeesIcons/security_1.svg";
import security_employeeIcon2 from "../assets/images/employeesIcons/security_2.svg";
import security_employeeIcon3 from "../assets/images/employeesIcons/security_3.svg";
import security_employeeIcon4 from "../assets/images/employeesIcons/security_4.svg";
import security_employeeIcon5 from "../assets/images/employeesIcons/security_5.svg";
import department_employeeIcon1 from "../assets/images/employeesIcons/department_1.svg";
import department_employeeIcon2 from "../assets/images/employeesIcons/department_2.svg";
import department_employeeIcon3 from "../assets/images/employeesIcons/department_3.svg";
import department_employeeIcon4 from "../assets/images/employeesIcons/department_4.svg";
import department_employeeIcon5 from "../assets/images/employeesIcons/department_5.svg";
import designation_employeeIcon1 from "../assets/images/employeesIcons/designation_1.svg";
import designation_employeeIcon2 from "../assets/images/employeesIcons/designation_2.svg";
import designation_employeeIcon3 from "../assets/images/employeesIcons/designation_3.svg";
import designation_employeeIcon4 from "../assets/images/employeesIcons/designation_4.svg";
import designation_employeeIcon5 from "../assets/images/employeesIcons/designation_5.svg";
import employees_employeeIcon1 from "../assets/images/employeesIcons/employees_1.svg";
import employees_employeeIcon2 from "../assets/images/employeesIcons/employees_2.svg";
import employees_employeeIcon3 from "../assets/images/employeesIcons/employees_3.svg";
import employees_employeeIcon4 from "../assets/images/employeesIcons/employees_4.svg";
import employees_employeeIcon5 from "../assets/images/employeesIcons/employees_5.svg";

export default function MainServices() {
  const {
    AxiosService,
    fetchData,
    fetchDataById,
    postData,
    patchData,
    deleteData,
  } = FetchServices();
  const versionPrefix = "api/v1";
  const config = useConfig();
  let myAccessToken;
  let session = localStorage.getItem(config?.sessionKey);
  if (session) {
    let sessionObject = JSON.parse(session);
    let { accessToken } = sessionObject;
    myAccessToken = accessToken;
  }

  const Services = {
    fileUpload: function (file) {
      let token = myAccessToken;
      console.log("main files: ", file);
      const api = config.api;
      let API = api + versionPrefix + apiService.uploadFile;
      var bodyFormData = new FormData();
      Array.isArray(file)
        ? file.forEach((eachFile) => bodyFormData.append("files", eachFile))
        : file && bodyFormData.append("files", file);
      console.log("main files bodyformdata", bodyFormData);
      return axios({
        method: "POST",
        url: API,
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=utf-8",
          Authorization: token,
        },
        data: bodyFormData,
      })
        .then(function (response) {
          return response;
        })
        .catch(function (error) {
          if (error?.response?.data?.status === 401) {
            localStorage.removeItem(config?.sessionKey);
            window.location.reload();
          }
          console.error("An error occurred in File Upload:", error);
          throw error;
        });
      // .then(function (response) {
      //   var resData = response;
      //   if (resData.status !== 201) {
      //     const message = resData.msg;
      //     const errorRes = { status: false, msg: message };
      //     return errorRes;
      //   }
      //   let headers = resData.headers;
      //   let fileName = headers["file-name"] && headers["file-name"];
      //   const apiResponse = { fileName, status: true, success: true };
      //   return { status: true, data: apiResponse, success: true };
      // })
      // .catch(function (res) {
      //   console.log(res);
      //   console.log("An error occurred in File Upload");
      // });
    },
    importEmployeeUpload: function (file) {
      let token = myAccessToken;
      console.log("main files: ", file);
      const api = config.api;
      let API = api + versionPrefix + apiService.importEmployee;
      var bodyFormData = new FormData();
      Array.isArray(file)
        ? file.forEach((eachFile) => bodyFormData.append("employee", eachFile))
        : file && bodyFormData.append("employee", file);
      console.log("main files bodyformdata", bodyFormData);
      return axios({
        method: "POST",
        url: API,
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=utf-8",
          Authorization: token,
        },
        data: bodyFormData,
      })
        .then(function (response) {
          return response;
        })
        .catch(function (error) {
          if (error?.response?.data?.status === 401) {
            localStorage.removeItem(config?.sessionKey);
            window.location.reload();
          }
          console.error("An error occurred in File Upload:", error);
          throw error;
        });
      // .then(function (response) {
      //   var resData = response;
      //   if (resData.status !== 201) {
      //     const message = resData.msg;
      //     const errorRes = { status: false, msg: message };
      //     return errorRes;
      //   }
      //   let headers = resData.headers;
      //   let fileName = headers["file-name"] && headers["file-name"];
      //   const apiResponse = { fileName, status: true, success: true };
      //   return { status: true, data: apiResponse, success: true };
      // })
      // .catch(function (res) {
      //   console.log(res);
      //   console.log("An error occurred in File Upload");
      // });
    },
    //   importContacts: function (file, details, token) {
    //     try {
    //       const API = config.crmApi + versionPrefix + apiService.importContacts;

    //       var bodyFormData = new FormData();
    //       file && bodyFormData.append("contact", file);
    //       // details &&
    //       //   Object.keys(details).map((eachkey) => {
    //       //     bodyFormData.append(eachkey, details[eachkey]);
    //       //     return true;
    //       //   });

    //       return axios({
    //         method: "POST",
    //         url: API,
    //         headers: {
    //           Authorization: token,
    //         },
    //         data: bodyFormData,
    //       })
    //         .then(function (response) {
    //           var resData = response.data;
    //           if (!resData) {
    //             const message = resData.msg;
    //             const errorRes = { status: false, msg: message };
    //             return errorRes;
    //           }
    //           const apiResponse = resData;
    //           return { status: true, data: apiResponse, success: true };
    //         })
    //         .catch(function (res) {
    //           console.log(res);
    //           console.log("An error occurred in File Upload");
    //         });
    //     } catch (error) {
    //       console.log(error);
    //     }
    //   },

    //   getContacts: function (details, token) {
    //     let API = config.crmApi + versionPrefix + apiService.getContacts;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },
    //   addContacts: function (details, token) {
    //     let API = config.crmApi + versionPrefix + apiService.addContacts;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "POST";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    //   updateContact: function (details, publicId, concurrencyStamp) {
    //     let API =
    //       config.crmApi +
    //       versionPrefix +
    //       apiService.updateContact +
    //       "/" +
    //       publicId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "PATCH";
    //     return AxiosService({
    //       API,
    //       payload,
    //       authNeeded: true,
    //       type,

    //       publicId,
    //       concurrencyStamp,
    //     }).then((res) => {
    //       return res;
    //     });
    //   },

    //   getContactsById: function (details, token) {
    //     let API = config.crmApi + versionPrefix + apiService.getContactsById;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    //   // country
    //   getCountry: function (details) {
    //     let API = config.api + versionPrefix + apiService.getCountry;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: false, type }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    //   addCompany: function (details, token) {
    //     let API = config.crmApi + versionPrefix + apiService.addCompany;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "POST";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    //   getState: function (details, token) {
    //     let API = config.api + versionPrefix + apiService.getState;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },
    //   getCompany: function (details, token) {
    //     let API = config.crmApi + versionPrefix + apiService.getCompany;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    //   //Campaign Apis
    //   addCampaign: function (details, token) {
    //     let API = config.crmApi + versionPrefix + apiService.addCampaign;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "POST";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    //   updateCampaign: function (details, publicId, concurrencyStamp) {
    //     let API =
    //       config.crmApi +
    //       versionPrefix +
    //       apiService.updateCampaign +
    //       "/" +
    //       publicId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "PATCH";
    //     return AxiosService({
    //       API,
    //       payload,
    //       authNeeded: true,
    //       type,

    //       publicId,
    //       concurrencyStamp,
    //     }).then((res) => {
    //       return res;
    //     });
    //   },

    //   deleteCampaign: function (details, publicId, concurrencyStamp) {
    //     let API =
    //       config.crmApi +
    //       versionPrefix +
    //       apiService.deleteCampaign +
    //       "/" +
    //       publicId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "DELETE";
    //     return AxiosService({
    //       API,
    //       payload,
    //       authNeeded: true,
    //       type,
    //       concurrencyStamp,
    //     }).then((res) => {
    //       return res;
    //     });
    //   },

    //   getCampaigns: function (details, token) {
    //     let API = config.crmApi + versionPrefix + apiService.getCampaigns;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    //   getCampaignById: function (details, publicId, token) {
    //     let API =
    //       config.crmApi +
    //       versionPrefix +
    //       apiService.getCampaigns +
    //       "/" +
    //       publicId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    //   // Campaign Contacts APIS
    //   addCampaignContact: function (details, token) {
    //     let API = config.crmApi + versionPrefix + apiService.addCampaignContact;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "POST";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    //   deleteCampaignContact: function (details, publicId, concurrencyStamp) {
    //     let API =
    //       config.crmApi +
    //       versionPrefix +
    //       apiService.deleteCampaignContact +
    //       "/" +
    //       publicId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "DELETE";
    //     return AxiosService({
    //       API,
    //       payload,
    //       authNeeded: true,
    //       type,
    //       concurrencyStamp,
    //     }).then((res) => {
    //       return res;
    //     });
    //   },

    //   getCampaignContacts: function (details, campaignId, token) {
    //     let API =
    //       config.crmApi +
    //       versionPrefix +
    //       apiService.getCampaignContacts +
    //       "/" +
    //       campaignId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    //   getNonCampaignContacts: function (details, campaignId, token) {
    //     let API =
    //       config.crmApi +
    //       versionPrefix +
    //       apiService.getNonCampaignContacts +
    //       "/" +
    //       campaignId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    // User functions
    userSignin: async function (details, clientDetails) {
      let API = config.api + versionPrefix + apiService.userSignin;
      // let API = "https://identity-test-service.awn.sa/api/v1/user/auth/login";
      const headers = {
        "client-id": clientDetails.clientId,
        "client-secret": clientDetails.clientSecret,
        "Content-Type": "application/json",
      };

      let payload = {
        ...details,
      };

      let type = "POST";

      try {
        const response = await axios.post(API, payload, { headers });
        return response; // Return response to the calling function
      } catch (error) {
        // if (error?.response?.data?.status === 401) {
        //   localStorage.removeItem(config?.sessionKey);
        //   window.location.reload();
        // }
        throw error.response ? error.response.data : error.message; // Throw error for handling in the calling function
      }
    },

    getCurrentUserRolePermissions: async function (details, accessToken) {
      const API =
        config.api + versionPrefix + apiService.currentUserRolePermissions;
      return fetchData(API, details, true, false, accessToken);
    },

    // userSignin: async function (details, clientDetails) {
    //   // let API = config.api + versionPrefix + apiService.userSignin;
    //   const payload = {
    //     ...details,
    //   };

    //   const type = "POST";

    //   try {
    //     const response = await axios.post(API, payload, { headers }, type);
    //     return response.data; // Return the response data
    //   } catch (error) {
    //     console.error("Error during API call:", error);
    //     throw error; // Rethrow the error or handle it as needed
    //   }
    // },

    //   userInfo: function (details, refreshToken, token) {
    //     let API = config.api + versionPrefix + apiService.userInfo;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({
    //       API,
    //       payload,
    //       authNeeded: true,
    //       type,
    //       refreshToken,
    //       token,
    //     }).then((res) => {
    //       return res;
    //     });
    //   },

    //   userRegistration: function (details) {
    //     let API = config.api + versionPrefix + apiService.userRegistration;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "POST";
    //     return AxiosService({ API, payload, authNeeded: false, type }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    forgetPassword: function (details) {
      let API = config.api + versionPrefix + apiService.forgetPassword;
      let payload = {
        ...details,
      };
      let type = "POST";
      return AxiosService({ API, payload, authNeeded: false, type }).then(
        (res) => {
          return res;
        }
      );
    },

    resetPassword: async function (details) {
      let API = config.api + versionPrefix + apiService.resetPassword;
      let payload = {
        ...details,
      };
      let type = "POST";
      return await AxiosService({ API, payload, authNeeded: false, type }).then(
        (res) => {
          return res;
        }
      );
    },

    changePassword: async function (details) {
      const API = config.api + versionPrefix + apiService.changePassword;
      return postData(API, details, true, true);
    },

    verifyOtp: function (details) {
      let API = config.api + versionPrefix + apiService.verifyOtp;
      let payload = {
        ...details,
      };
      let type = "POST";
      return AxiosService({ API, payload, authNeeded: false, type }).then(
        (res) => {
          return res;
        }
      );
    },

    //   userGoogleSignin: function () {
    //     let API = config.api + apiService.userGoogleSignin;
    //     window.open(API, "_self");
    //   },

    //   userFacebookSignin: function () {
    //     let API = config.api + apiService.userFacebookSignin;
    //     window.open(API, "_self");
    //   },

    //   getUserDetails: function (details, token) {
    //     let API = config.api + versionPrefix + apiService.getUserDetails;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    //   getCountryList: function (details) {
    //     let API = config.api + versionPrefix + apiService.getCountryList;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: false, type }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    //   resetpassword: function (details, publicId, concurrencyStamp) {
    //     let API = config.api + apiService.resetpassword + "/" + publicId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "PATCH";
    //     return AxiosService({
    //       API,
    //       payload,
    //       authNeeded: true,
    //       type,
    //       concurrencyStamp,
    //     }).then((res) => {
    //       return res;
    //     });
    //   },
    //   //permission api
    //   getRolePermissionsByRoles: function (details, token) {
    //     let API = config.api + apiService.getRolePermissionsByRoles;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },
    //   getAllPermission: function (details, token) {
    //     let API = config.api + apiService.getAllPermission;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    //   //wosol

    //   //warehouse
    //   getWarehouseData: function () {
    //     return [
    //       {
    //         warehouseName: "Warehouse1 (WH1)",
    //         location: "Riyadh",
    //         address: "16 Al-Jurah Street, Tabuk",
    //         contactNumber: "+966581062534",
    //         emailAddress: "warehouse@gmail.com",
    //         status: "inactive",
    //       },
    //       {
    //         warehouseName: "Warehouse2 (WH2)",
    //         location: "Riyadh",
    //         address: "64 Wadi Al-Jeje Street, Khobar",
    //         contactNumber: "+966581062534",
    //         emailAddress: "warehouse@gmail.com",
    //         status: "active",
    //       },
    //       {
    //         warehouseName: "Warehouse2 (WH2)",
    //         location: "Riyadh",
    //         address: "64 Wadi Al-Jeje Street, Khobar",
    //         contactNumber: "+966581062534",
    //         emailAddress: "warehouse@gmail.com",
    //         status: "active",
    //       },
    //       {
    //         warehouseName: "Warehouse2 (WH2)",
    //         location: "Riyadh",
    //         address: "64 Wadi Al-Jeje Street, Khobar",
    //         contactNumber: "+966581062534",
    //         emailAddress: "warehouse@gmail.com",
    //         status: "active",
    //       },
    //       {
    //         warehouseName: "Warehouse2 (WH2)",
    //         location: "Riyadh",
    //         address: "64 Wadi Al-Jeje Street, Khobar",
    //         contactNumber: "+966581062534",
    //         emailAddress: "warehouse@gmail.com",
    //         status: "active",
    //       },
    //     ];
    //   },

    //   getCheckInData: function () {
    //     return [
    //       {
    //         checkInID: "ID: 70668",
    //         type: "Rent",
    //         customerName: "Mu'ayyad Al-Zahrani",
    //         warehouse: "Warehouse 1 (WH1)",
    //         employee: "Mansour bin Zayed",
    //         contactNumber: "+966595333999",
    //       },
    //     ];
    //   },
    //   getCheckOutData: function () {
    //     return [
    //       {
    //         checkInID: "ID: 70668",
    //         type: "Rent",
    //         customerName: "Mu'ayyad Al-Zahrani",
    //         warehouse: "Warehouse 1 (WH1)",
    //         employee: "Mansour bin Zayed",
    //         contactNumber: "+966595333999",
    //       },
    //     ];
    //   },

    //   //work order
    //   getWorkOrdersData: function () {
    //     return [
    //       {
    //         orderNumber: "WON: 70668",
    //         issueDate: "20.02.2024",
    //         companyName: "ABC Construction",
    //         clientName: "Mana Salem",
    //         contactNumber: "+966595333999",
    //         projectSite: "57 Sahil Street, Abha",
    //       },
    //     ];
    //   },

    //   //inventory
    getProductsData: function () {
      return [
        {
          productCode: "PC _ 01",
          productName: "Product _ Name",
          category: "Category _ Here",
          uoms: "PC",
          quantity: "100",
        },
        {
          productCode: "PC _ 01",
          productName: "Product _ Name",
          category: "Category _ Here",
          uoms: "PC",
          quantity: "100",
        },
      ];
    },

    //   getProductCategoryData: function () {
    //     return [
    //       {
    //         productCode: "PC _ 01",
    //         productName: "Product _ Name",
    //         category: "Category _ Here",
    //         uoms: "PC",
    //         quantity: "100",
    //       },
    //       {
    //         productCode: "PC _ 01",
    //         productName: "Product _ Name",
    //         category: "Category _ Here",
    //         uoms: "PC",
    //         quantity: "100",
    //       },
    //     ];
    //   },

    //   getUnitsData: function () {
    //     return [
    //       {
    //         name: "Centimeter",
    //         shortName: "Cm",
    //         baseUoms: "Meter",
    //         operator: "100",
    //         operationValue: "/",
    //       },
    //       {
    //         name: "Dozen Box",
    //         shortName: "Box",
    //         baseUoms: "Pieces",
    //         operator: "12",
    //         operationValue: "*",
    //       },
    //     ];
    //   },

    //   getStocktakingData: function () {
    //     return [
    //       {
    //         productCode: "PC _ 01",
    //         productName: "Product _ Name",
    //         category: "Category _ Here",
    //         from: "Warehouse _ 02",
    //         to: "Warehouse _ 01",
    //         quantity: "100",
    //       },
    //       {
    //         productCode: "PC _ 01",
    //         productName: "Product _ Name",
    //         category: "Category _ Here",
    //         from: "Warehouse _ 02",
    //         to: "Warehouse _ 01",
    //         quantity: "100",
    //       },
    //     ];
    //   },

    //   //users
    //   getEmployeesData: function () {
    //     return [
    //       {
    //         employeeId: "EMP _ 01",
    //         userName: "Baha'a Al-Atif Al-Othman",
    //         role: "Role _ Here",
    //         designation: "Designation _ Here",
    //         department: "Department _ Here",
    //         contactNumber: "+966 12548796",
    //         email: "a@gmail.com",
    //       },
    //     ];
    //   },
    //   getClientData: function () {
    //     return [
    //       {
    //         clientId: "Client _ 01",
    //         clientName: "Baha'a Al-Atif Al-Othman",
    //         contactPerson: "Person Name",
    //         mobileNo: "+966 12548796",
    //         email: "a@gmail.com",
    //         addedBy: "Wosol Admin",
    //         addDate: "20.02.2024",
    //       },
    //     ];
    //   },

    //   // accounts
    //   getJournalEntries: function () {
    //     return [
    //       {
    //         entryNumber: "Client _ 01",
    //         accountName: "Baha'a Al-Atif Al-Othman",
    //         costCenter: "Person Name",
    //         currency: "+966 12548796",
    //         debitAmount: "a@gmail.com",
    //         creditAmount: "Wosol Admin",
    //         totalAmount: "20.02.2024",
    //         projectCode: "20.02.2024",
    //         date: "20.02.2024",
    //       },
    //     ];
    //   },

    //   getCostCenters: function () {
    //     return [
    //       {
    //         code: "Client _ 01",
    //         costCenters: "Baha'a Al-Atif Al-Othman",
    //         parentCostCenter: "Person Name",
    //       },
    //     ];
    //   },

    //   getAssets: function () {
    //     return [
    //       {
    //         code: "Client _ 01",
    //         assetName: "Baha'a Al-Atif Al-Othman",
    //         categoryAccount: "Person Name",
    //         location: "+966 12548796",
    //         usefulLife: "a@gmail.com",
    //         quantity: "Wosol Admin",
    //         purchaseAmount: "20.02.2024",
    //         purchaseDate: "20.02.2024",
    //         inServiceDate: "20.02.2024",
    //       },
    //     ];
    //   },

    //   // finance

    //   getExpenses: function () {
    //     return [
    //       {
    //         code: "Client _ 01",
    //         vendor: "Baha'a Al-Atif Al-Othman",
    //         category: "Person Name",
    //         journalAccount: "+966 12548796",
    //         supplier: "a@gmail.com",
    //         paymentMethod: "Wosol Admin",
    //         date: "20.02.2024",
    //       },
    //     ];
    //   },

    //   getIncome: function () {
    //     return [
    //       {
    //         code: "Client _ 01",
    //         vendor: "Baha'a Al-Atif Al-Othman",
    //         category: "Person Name",
    //         journalAccount: "+966 12548796",
    //         receivedBy: "a@gmail.com",
    //         paymentMethod: "Wosol Admin",
    //         date: "20.02.2024",
    //       },
    //     ];
    //   },

    //   getBankAccount: function () {
    //     return [
    //       {
    //         accountNumber: "Client _ 01",
    //         accountHolderName: "Baha'a Al-Atif Al-Othman",
    //         bankName: "Person Name",
    //         currency: "+966 12548796",
    //         status: "active",
    //       },
    //       {
    //         accountNumber: "Client _ 01",
    //         accountHolderName: "Baha'a Al-Atif Al-Othman",
    //         bankName: "Person Name",
    //         currency: "+966 12548796",
    //         status: "inactive",
    //       },
    //     ];
    //   },

    //   getTreasuries: function () {
    //     return [
    //       {
    //         treasuryName: "Client _ 01",
    //         type: "Baha'a Al-Atif Al-Othman",
    //         currency: "Person Name",
    //         maxLimit: "+966 12548796",
    //         status: "active",
    //       },
    //       {
    //         treasuryName: "Client _ 01",
    //         type: "Baha'a Al-Atif Al-Othman",
    //         currency: "Person Name",
    //         maxLimit: "+966 12548796",
    //         status: "active",
    //       },
    //     ];
    //   },

    //   // customer
    //   getCustomer: function () {
    //     return [
    //       {
    //         partyName: "Baha'a Al-Atif Al-Othman",
    //         mobileNo: "+966 12548796",
    //         email: "contact@bahaa.com",
    //         openingAmt: "50000",
    //         gstNo: "GST1234567890",
    //         panNo: "ABCDE1234F",
    //         creditPeriod: "30 days",
    //         creditLimit: "200000",
    //         countryId: { value: "IN", label: "India" },
    //         stateId: { value: "MH", label: "Maharashtra" },
    //         billingDoorNo: "123",
    //         billingAddress1: "Main St",
    //         billingAddress2: "Near the Park",
    //         billingCity: "Solapur",
    //         billingCountryId: { value: "IN", label: "India" },
    //         billingStateId: { value: "MH", label: "Maharashtra" },
    //         billingPinCode: "413003",
    //         shippingDoorNo: "456",
    //         shippingAddress1: "Elm St",
    //         shippingAddress2: "Opposite Hospital",
    //         shippingCity: "Solapur",
    //         shippingCountryId: { value: "IN", label: "India" },
    //         shippingStateId: { value: "MH", label: "Maharashtra" },
    //         shippingPinCode: "413004",
    //       },
    //     ];
    //   },

    //   // parties

    //   getPartyData: function () {
    //     return [
    //       {
    //         partyName: "Baha'a Al-Atif Al-Othman",
    //         mobileNo: "+966 12548796",
    //         email: "contact@bahaa.com",
    //         openingAmt: "50000",
    //         gstNo: "GST1234567890",
    //         panNo: "ABCDE1234F",
    //         creditPeriod: "30 days",
    //         creditLimit: "200000",
    //         countryId: { value: "IN", label: "India" },
    //         stateId: { value: "MH", label: "Maharashtra" },
    //         billingDoorNo: "123",
    //         billingAddress1: "Main St",
    //         billingAddress2: "Near the Park",
    //         billingCity: "Solapur",
    //         billingCountryId: { value: "IN", label: "India" },
    //         billingStateId: { value: "MH", label: "Maharashtra" },
    //         billingPinCode: "413003",
    //         shippingDoorNo: "456",
    //         shippingAddress1: "Elm St",
    //         shippingAddress2: "Opposite Hospital",
    //         shippingCity: "Solapur",
    //         shippingCountryId: { value: "IN", label: "India" },
    //         shippingStateId: { value: "MH", label: "Maharashtra" },
    //         shippingPinCode: "413004",
    //       },
    //     ];
    //   },

    //   // items / product

    //   // Product Management
    getBranchDataNew: function () {
      return [
        {
          select: false,
          branchId: "BRANCH _ 01",
          branchName: "Branch Name _ Here",
          branchAdmin: {
            name: "Employee Name",
            email: "admin@xyz.com",
            image: employeeIcon, // Working image URL for admin
          },
          location: "Location _ Here",
          status: "active",
          action: "view", // Example action
        },
        {
          select: false,
          branchId: "BRANCH _ 01",
          branchName: "Branch Name _ Here",
          branchAdmin: {
            name: "Employee Name",
            email: "admin@xyz.com",
            image: employeeIcon, // Working image URL for admin
          },
          location: "Location _ Here",
          status: "active",
          action: "view", // Example action
        },
        {
          select: false,
          branchId: "BRANCH _ 01",
          branchName: "Branch Name _ Here",
          branchAdmin: {
            name: "Employee Name",
            email: "admin@xyz.com",
            image: employeeIcon, // Working image URL for admin
          },
          location: "Location _ Here",
          status: "active",
          action: "view", // Example action
        },
        {
          select: false,
          branchId: "BRANCH _ 01",
          branchName: "Branch Name _ Here",
          branchAdmin: {
            name: "Employee Name",
            email: "admin@xyz.com",
            image: employeeIcon, // Working image URL for admin
          },
          location: "Location _ Here",
          status: "active",
          action: "view", // Example action
        },
        {
          select: false,
          branchId: "BRANCH _ 01",
          branchName: "Branch Name _ Here",
          branchAdmin: {
            name: "Employee Name",
            email: "admin@xyz.com",
            image: employeeIcon, // Working image URL for admin
          },
          location: "Location _ Here",
          status: "active",
          action: "view", // Example action
        },
        {
          select: false,
          branchId: "BRANCH _ 01",
          branchName: "Branch Name _ Here",
          branchAdmin: {
            name: "Employee Name",
            email: "admin@xyz.com",
            image: employeeIcon, // Working image URL for admin
          },
          location: "Location _ Here",
          status: "active",
          action: "view", // Example action
        },
        {
          select: false,
          branchId: "BRANCH _ 01",
          branchName: "Branch Name _ Here",
          branchAdmin: {
            name: "Employee Name",
            email: "admin@xyz.com",
            image: employeeIcon, // Working image URL for admin
          },
          location: "Location _ Here",
          status: "active",
          action: "view", // Example action
        },
      ];
    },
    getRoleDataNew: function () {
      return [
        {
          roleId: "R001",
          roleCode: "RC _ 01",
          roleName: "Full Stack Software Engineeri",
          createdBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: role_employeeIcon1, // Working image URL for admin
          },
          status: "active",
          action: "view", // Example action
        },
        {
          roleId: "R001",
          roleCode: "RC _ 02",
          roleName: "Senior Product Manager",
          createdBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: role_employeeIcon2, // Working image URL for admin
          },
          status: "active",
          action: "view", // Example action
        },
        {
          roleId: "R001",
          roleCode: "RC _ 03",
          roleName: "Design Manager",
          createdBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: role_employeeIcon3, // Working image URL for admin
          },
          status: "active",
          action: "view", // Example action
        },
        {
          roleId: "R001",
          roleCode: "RC _ 04",
          roleName: "Head of Content Operations",
          createdBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: role_employeeIcon4, // Working image URL for admin
          },
          status: "active",
          action: "view", // Example action
        },
        {
          roleId: "R001",
          roleCode: "RC _ 05",
          roleName: "Head of Engineering",
          createdBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: role_employeeIcon5, // Working image URL for admin
          },
          status: "active",
          action: "view", // Example action
        },
      ];
    },
    getSecurityGroupDataNew: function () {
      return [
        {
          securityGroupId: "SG001",
          groupID: "GROUP_01",
          groupName: "Group Name _ 01",
          members: "+10",
          createBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: security_employeeIcon1, // Working image URL for admin
          },
          createDate: "20.02.2024",
          status: "active",
          action: "view", // Example action
        },
        {
          securityGroupId: "SG001",
          groupID: "GROUP_02",
          groupName: "Group Name _ 02",
          members: "+10",
          createBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: security_employeeIcon2, // Working image URL for admin
          },
          createDate: "20.02.2024",
          status: "active",
          action: "view", // Example action
        },
        {
          securityGroupId: "SG001",
          groupID: "GROUP_03",
          groupName: "Group Name _ 03",
          members: "+10",
          createBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: security_employeeIcon3, // Working image URL for admin
          },
          createDate: "20.02.2024",
          status: "active",
          action: "view", // Example action
        },
        {
          securityGroupId: "SG001",
          groupID: "GROUP_04",
          groupName: "Group Name _ 04",
          members: "+10",
          createBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: security_employeeIcon4, // Working image URL for admin
          },
          createDate: "20.02.2024",
          status: "active",
          action: "view", // Example action
        },
        {
          securityGroupId: "SG001",
          groupID: "GROUP_05",
          groupName: "Group Name _ 05",
          members: "+10",
          createBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: security_employeeIcon5, // Working image URL for admin
          },
          createDate: "20.02.2024",
          status: "active",
          action: "view", // Example action
        },
      ];
    },

    getDepartmentDataNew: function () {
      return [
        {
          departmentId: "D001",
          departmentCode: "DC _ 01",
          departmentName: "Furniture",
          createdBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: department_employeeIcon1, // Working image URL for admin
          },
          status: "active",
          action: "view", // Example action
        },
        {
          departmentId: "D001",
          departmentCode: "DC _ 02",
          departmentName: "Visual Effects",
          createdBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: department_employeeIcon2, // Working image URL for admin
          },
          status: "active",
          action: "view", // Example action
        },
        {
          departmentId: "D001",
          departmentCode: "DC _ 03",
          departmentName: "Interaction",
          createBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: department_employeeIcon3, // Working image URL for admin
          },
          status: "active",
          action: "view", // Example action
        },
        {
          departmentId: "D001",
          departmentCode: "DC _ 04",
          departmentName: "Web",
          createBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: department_employeeIcon4, // Working image URL for admin
          },
          status: "active",
          action: "view", // Example action
        },
        {
          departmentId: "D001",
          departmentCode: "DC _ 05",
          departmentName: "Painting",
          createBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: department_employeeIcon5, // Working image URL for admin
          },
          status: "active",
          action: "view", // Example action
        },
      ];
    },
    getDesignationDataNew: function () {
      return [
        {
          designationId: "DS001",
          designationCode: "DC _ 01",
          designationName: "Architect",
          createdBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: designation_employeeIcon1, // Working image URL for admin
          },
          status: "active",
          action: "view", // Example action
        },
        {
          designationId: "DS001",
          designationCode: "DC _ 02",
          designationName: "Programmer Analyst",
          createdBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: designation_employeeIcon2, // Working image URL for admin
          },
          status: "active",
          action: "view", // Example action
        },
        {
          designationId: "DS001",
          designationCode: "DC _ 03",
          designationName: "Trainee Engineer",
          createBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: designation_employeeIcon3, // Working image URL for admin
          },
          status: "active",
          action: "view", // Example action
        },
        {
          designationId: "DS001",
          designationCode: "DC _ 04",
          designationName: "Chief Financial Officer",
          createBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: designation_employeeIcon4, // Working image URL for admin
          },
          status: "active",
          action: "view", // Example action
        },
        {
          designationId: "DS001",
          designationCode: "DC _ 05",
          designationName: "Chief Marketing Officer",
          createBy: {
            name: "Jane Cooper",
            email: "JaneCooper@awn.com",
            image: designation_employeeIcon5, // Working image URL for admin
          },
          status: "active",
          action: "view", // Example action
        },
      ];
    },
    getEmployeesDataNew: function () {
      return [
        {
          employeesId: "EM001",
          employeeId: "A100124",
          employeeName: {
            name: "Abdul Salam",
            email: "abdulsalam@awn.sa",
            image: employees_employeeIcon1, // Working image URL for admin
          },
          designation: "Operations Manager",
          role: "Role _ Here",
          department: "Department _ Here",
          status: "active",
          action: "view", // Example action
        },
        {
          employeesId: "EM001",
          employeeId: "A100224",
          employeeName: {
            name: "Basil",
            email: "basil@awn.sa",
            image: employees_employeeIcon2, // Working image URL for admin
          },
          designation: "Business Dev Manager",
          role: "Role _ Here",
          department: "Department _ Here",
          status: "active",
          action: "view", // Example action
        },
        {
          employeesId: "EM001",
          employeeId: "A100325",
          employeeName: {
            name: "Ahmed",
            email: "ahmed@awn.sa",
            image: employees_employeeIcon3, // Working image URL for admin
          },
          designation: "Account Manager",
          role: "Role _ Here",
          department: "Department _ Here",
          status: "Inactive",
          action: "view", // Example action
        },
        {
          employeesId: "EM001",
          employeeId: "A100425",
          employeeName: {
            name: "Waleed",
            email: "Waleed@awn.sa",
            image: employees_employeeIcon4, // Working image URL for admin
          },
          designation: "HR Manager",
          role: "Role _ Here",
          department: "Department _ Here",
          status: "active",
          action: "view", // Example action
        },
        {
          employeesId: "EM001",
          employeeId: "A100425",
          employeeName: {
            name: "Waleed",
            email: "Waleed@awn.sa",
            image: employees_employeeIcon5, // Working image URL for admin
          },
          designation: "HR Manager",
          role: "Role _ Here",
          department: "Department _ Here",
          status: "active",
          action: "view", // Example action
        },
      ];
    },

    //   // payables

    //   getPurchaseOrder: function () {
    //     return [
    //       {
    //         party: "Acme Corporation",
    //         purchaseOrderNo: "PO12345",
    //         purchaseOrderDate: "2024-02-20",
    //         supplier: "Supplier _ 01",
    //         status: "Pending",
    //         paymentTerms: "Net 30",
    //         dueDate: "2024-03-21",
    //         rows: [
    //           {
    //             item: { value: "PRD001", label: "Product A" },
    //             description: "High-quality widget",
    //             unitPrice: 500,
    //             quantity: 10,
    //             discount: { value: 5, label: "5%" },
    //             subtotal: 4750,
    //           },
    //           {
    //             item: { value: "PRD002", label: "Product B" },
    //             description: "Advanced gadget",
    //             unitPrice: 300,
    //             quantity: 5,
    //             discount: { value: 10, label: "10%" },
    //             subtotal: 1350,
    //           },
    //         ],
    //         attachments: [
    //           {
    //             fileName: "invoice.pdf",
    //             url: "https://example.com/invoice.pdf",
    //           },
    //         ],
    //       },
    //     ];
    //   },

    //   // purchase
    //   getPurchaseRequest: function () {
    //     return [
    //       {
    //         party: "Global Tech Solutions",
    //         supplier: "Supplier _ 01",
    //         purchaseReqNo: "REQ20231234",
    //         purchaseReqDate: "2024-02-10",
    //         status: "Pending",
    //         paymentTerms: "Net 15",
    //         dueDate: "2024-02-25",
    //         rows: [
    //           {
    //             item: { value: "ITM001", label: "Laptop - Model X" },
    //             description: "High-performance laptop for software development",
    //             unitPrice: 1500,
    //             quantity: 3,
    //             discount: { value: 10, label: "10%" },
    //             subtotal: 4050,
    //           },
    //           {
    //             item: { value: "ITM002", label: "Wireless Mouse" },
    //             description: "Ergonomic wireless mouse",
    //             unitPrice: 50,
    //             quantity: 5,
    //             discount: { value: 5, label: "5%" },
    //             subtotal: 237.5,
    //           },
    //         ],
    //         attachments: [
    //           {
    //             fileName: "purchase_request.pdf",
    //             url: "https://example.com/purchase_request.pdf",
    //           },
    //         ],
    //       },
    //     ];
    //   },

    //   getPurchaseInvoice: function () {
    //     return [
    //       {
    //         piNumber: "Client _ 01",
    //         supplier: "Baha'a Al-Atif Al-Othman",
    //         item: "Person Name",
    //         unitPrice: "+966 12548796",
    //         quantity: "a@gmail.com",
    //         status: "Approved",
    //         discount: "Wosol Admin",
    //         date: "20.02.2024",
    //       },
    //     ];
    //   },

    //   getDebitNote: function () {
    //     return [
    //       {
    //         siNumber: "SI-2024-01",
    //         invoiceDate: "2024-12-06",
    //         paymentTerms: "Net 30",
    //         supplier: "Supplier",
    //         status: "Unpaid",
    //         dueDate: "2025-01-05",
    //         attachments: [
    //           { name: "Invoice1.pdf", url: "https://example.com/invoice1.pdf" },
    //           { name: "Invoice2.pdf", url: "https://example.com/invoice2.pdf" },
    //         ],
    //         rows: [
    //           {
    //             item: { value: "Item-001", label: "Laptop" },
    //             description: "Dell Latitude 7420",
    //             unitPrice: 75000,
    //             quantity: 2,
    //             discount: { value: 10, label: "10%" },
    //             subtotal: 135000,
    //           },
    //           {
    //             item: { value: "Item-002", label: "Monitor" },
    //             description: "Dell UltraSharp 24",
    //             unitPrice: 15000,
    //             quantity: 1,
    //             discount: { value: 5, label: "5%" },
    //             subtotal: 14250,
    //           },
    //         ],
    //         additionalCharges: [
    //           {
    //             label: "Shipping",
    //             value: 500,
    //           },
    //           {
    //             label: "Installation",
    //             value: 1000,
    //           },
    //         ],
    //         taxableAmount: "136250",
    //         totalAmount: "137750",
    //         signature: "Authorized Signature",
    //       },
    //     ];
    //   },

    //   getPurchaseRefund: function () {
    //     return [
    //       {
    //         refundNumber: "Client _ 01",
    //         supplier: "Baha'a Al-Atif Al-Othman",
    //         item: "Person Name",
    //         unitPrice: "+966 12548796",
    //         quantity: "a@gmail.com",
    //         status: "Pending",
    //         discount: "Wosol Admin",
    //         refundDate: "20.02.2024",
    //       },
    //     ];
    //   },

    //   // getDebitNote: function () {
    //   //   return [
    //   //     {
    //   //       code: "Client _ 01",
    //   //       supplier: "Baha'a Al-Atif Al-Othman",
    //   //       item: "Person Name",
    //   //       unitPrice: "+966 12548796",
    //   //       quantity: "a@gmail.com",
    //   //       discount: "Wosol Admin",
    //   //       debitDate: "20.02.2024",
    //   //     },
    //   //   ];
    //   // },

    //   getSuppliers: function () {
    //     return [
    //       {
    //         supplierId: "Client _ 01",
    //         businessName: "Baha'a Al-Atif Al-Othman",
    //         contactPerson: "Person Name",
    //         telephoneNo: "+966 12548796",
    //         email: "a@gmail.com",
    //         product: "Wosol Admin",
    //         addedBy: "20.02.2024",
    //         addDate: "20.02.2024",
    //       },
    //     ];
    //   },

    //   getSuppliersPayment: function () {
    //     return [
    //       {
    //         piNumber: "Client _ 01",
    //         paymentNo: "Baha'a Al-Atif Al-Othman",
    //         supplier: "Person Name",
    //         paymentMethod: "+966 12548796",
    //         date: "20.02.2024",
    //       },
    //     ];
    //   },

    //   // settings

    //   getPaymentTerms: function () {
    //     return [
    //       {
    //         name: "Payment Policy",
    //         description: "This is payment policy",
    //       },
    //       {
    //         name: "Pa",
    //         description: "Th",
    //       },
    //     ];
    //   },

    //   // sales

    //   getSalesInvoice: function () {
    //     return [
    //       {
    //         invoiceNo: "Client _ 01",
    //         client: "Baha'a Al-Atif Al-Othman",
    //         item: "Person Name",
    //         unitPrice: "+966 12548796",
    //         quantity: "a@gmail.com",
    //         discount: "Wosol Admin",
    //         status: "Pending",
    //         date: "20.02.2024",
    //       },
    //     ];
    //   },

    //   getEstimates: function () {
    //     return [
    //       {
    //         estimateNo: "Client _ 01",
    //         client: "Baha'a Al-Atif Al-Othman",
    //         item: "Person Name",
    //         unitPrice: "+966 12548796",
    //         quantity: "a@gmail.com",
    //         discount: "Wosol Admin",
    //         date: "20.02.2024",
    //       },
    //     ];
    //   },

    //   getCreditNotes: function () {
    //     return [
    //       {
    //         creditNoteNo: "Client _ 01",
    //         client: "Baha'a Al-Atif Al-Othman",
    //         item: "Person Name",
    //         unitPrice: "+966 12548796",
    //         quantity: "a@gmail.com",
    //         discount: "Wosol Admin",
    //         date: "20.02.2024",
    //       },
    //     ];
    //   },

    //   getRecurringInvoices: function () {
    //     return [
    //       {
    //         creditNoteNo: "Client _ 01",
    //         subscriptionName: "Subscription _ Name",
    //         client: "Baha'a Al-Atif Al-Othman",
    //         item: "Person Name",
    //         unitPrice: "+966 12548796",
    //         quantity: "a@gmail.com",
    //         discount: "Wosol Admin",
    //         generateInvoice: "1st Of Every Month",
    //       },
    //     ];
    //   },

    //   // employees

    //   getEmployees: function () {
    //     return [
    //       {
    //         employeeId: "EMP _ 01",
    //         userName: "Baha'a Al-Atif Al-Othman",
    //         role: "Role _ Here",
    //         code: "India",
    //         designation: "Designation _ Here",
    //         department: "Department _ Here",
    //         contactNumber: "+966 12548796",
    //         email: "a@gmail.com",
    //       },
    //     ];
    //   },

    //   getDesignations: function () {
    //     return [
    //       {
    //         designationName: "DEGN _ 01",
    //         code: "Baha'a Al-Atif Al-Othman",
    //         description: "Role _ Here",
    //       },
    //     ];
    //   },

    //   getDepartment: function () {
    //     return [
    //       {
    //         departmentName: "DEGN _ 01",
    //         code: "Baha'a Al-Atif Al-Othman",
    //         description: "Role _ Here",
    //       },
    //     ];
    //   },

    //   getRole: function () {
    //     return [
    //       {
    //         roleName: "Role _ 01",
    //         code: "Baha'a Al-Atif Al-Othman",
    //         description: "Role _ Here",
    //       },
    //     ];
    //   },

    //   // Quotation Management
    //   getQuotation: function () {
    //     return [
    //       {
    //         quotationNo: "Client _ 01",
    //         warehouse: "Subscription _ Name",
    //         client: "Baha'a Al-Atif Al-Othman",
    //         projectName: "Person Name",
    //         product: "+966 12548796",
    //         grandTotal: "a@gmail.com",
    //         date: "Wosol Admin",
    //         status: "Send",
    //       },
    //     ];
    //   },

    //   // Transport

    //   getTransportation: function () {
    //     return [
    //       {
    //         transportationId: "Client _ 01",
    //         transportationType: "Baha'a Al-Atif Al-Othman",
    //         startLocation: "Person Name",
    //         destination: "+966 12548796",
    //         vehicleNo: "a@gmail.com",
    //         driverName: "Wosol Admin",
    //         pickUpDateTime: "20.02.2024",
    //         deliveryDateTime: "20.02.2024",
    //       },
    //     ];
    //   },

    //   getVehicle: function () {
    //     return [
    //       {
    //         vehicleId: "Client _ 01",
    //         vehicleName: "Baha'a Al-Atif Al-Othman",
    //         vehicleModal: "Baha'a Al-Atif Al-Othman",
    //         registrationNo: "Person Name",
    //         vehicleType: "Baha'a Al-Atif Al-Othman",
    //         capacity: "+966 12548796",
    //         maintenanceDueDate: "a@gmail.com",
    //         status: "Active",
    //       },
    //     ];
    //   },

    //   getDriver: function () {
    //     return [
    //       {
    //         driverId: "Client _ 01",
    //         driverName: "Baha'a Al-Atif Al-Othman",
    //         mobileNo: "Baha'a Al-Atif Al-Othman",
    //         licenseNo: "Person Name",
    //         licenseExpiry: "Baha'a Al-Atif Al-Othman",
    //         assignedVehicle: "+966 12548796",
    //         status: "Active",
    //       },
    //     ];
    //   },

    //   // Procurement

    //   getPurchaseRequests: function () {
    //     return [
    //       {
    //         requestId: "Client _ 01",
    //         type: "Baha'a Al-Atif Al-Othman",
    //         department: "Baha'a Al-Atif Al-Othman",
    //         itemName: "Person Name",
    //         quantity: "Baha'a Al-Atif Al-Othman",
    //         priority: "+966 12548796",
    //         approverName: "a@gmail.com",
    //         dateOfReq: "a@gmail.com",
    //         status: "Active",
    //       },
    //     ];
    //   },

    //   getQuotationRequests: function () {
    //     return [
    //       {
    //         requestId: "Client _ 01",
    //         contactPerson: "Baha'a Al-Atif Al-Othman",
    //         vendorName: "Baha'a Al-Atif Al-Othman",
    //         itemName: "Person Name",
    //         quantity: "Baha'a Al-Atif Al-Othman",
    //         mobileNo: "+966 12548796",
    //         email: "a@gmail.com",
    //         deliveryDeadline: "a@gmail.com",
    //       },
    //     ];
    //   },

    //   getVendorEvaluation: function () {
    //     return [
    //       {
    //         quotationId: "Client _ 01",
    //         serviceName: "Baha'a Al-Atif Al-Othman",
    //         vendorName: "Baha'a Al-Atif Al-Othman",
    //         itemName: "Person Name",
    //         qualityEvaluation: "Person Name",
    //         pricingEval: "Person Name",
    //         prevPerfomance: "Person Name",
    //         deliveryTimeEval: "Person Name",
    //         isRecommended: "Person Name",
    //       },
    //     ];
    //   },

    //   // contracts

    //   getContracts: function () {
    //     return [
    //       {
    //         contractId: "Client _ 01",
    //         quotationId: "Subscription _ Name",
    //         type: "Baha'a Al-Atif Al-Othman",
    //         customer: "Person Name",
    //         supplier: "+966 12548796",
    //         date: "a@gmail.com",
    //         status: "Approved",
    //       },
    //     ];
    //   },

    //   addWarehouse: function (details) {
    //     let API = config.api + apiService.addRelationType;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "POST";
    //     return AxiosService({ API, payload, authNeeded: true, type }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    //   getWarehouse: function (details) {
    //     let API = config.rmdAPi + apiService.getCategoryType;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    //   // employees / staff

    getEmployeesMasterData: async function (details) {
      const API = config.api + versionPrefix + apiService.getEmployeesInfo;
      return fetchData(API, details, true, false);
    },

    getEmployeesMaster: async function (details, token) {
      let API = config.api + versionPrefix + apiService.getEmployeesInfo;
      let payload = {
        ...details,
      };
      try {
        const response = await axios.get(API, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: payload, // If `details` contains query params, pass them here
        });
        return response; // Return response to the calling function
      } catch (error) {
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem(config?.sessionKey);
          window.location.reload();
        }
        throw error;
      }
    },

    getEmployeeRegistration: async function (details, accessToken = null) {
      const API =
        config.api + versionPrefix + apiService.getEmployeesRegistration;
      return fetchData(API, details, true, false, accessToken);
    },

    addEmployeeMaster: async function (details) {
      const API =
        config.api + versionPrefix + apiService.getEmployeesRegistration;
      return postData(API, details, true, true);
    },

    updateEmployeeRegistrationMaster: async function (
      details,
      publicId,
      concurrencyStamp
    ) {
      const API =
        config.api +
        versionPrefix +
        apiService.employeeRegistration +
        `/${publicId}`;
      return patchData(API, details, true, true, false, concurrencyStamp);
    },

    getEmployeesRegistrationById: async function (publicId) {
      const API =
        config.api +
        versionPrefix +
        apiService.employeeRegistrationById +
        `/${publicId}`;
      return fetchDataById(API, true, true);
    },

    deactivateEmployeeMaster: async function (publicId, concurrencyStamp) {
      const API = config.api + versionPrefix + apiService.user + `/${publicId}`;
      return deleteData(API, null, true, true, concurrencyStamp);
    },

    fetchEmployeeRegistrationDataById: async function (publicId) {
      const API =
        config.api +
        versionPrefix +
        apiService.employeeRegistrationById +
        `/${publicId}`;
      return fetchDataById(API, true, false);
    },

    fetchEmployeeEmployementInfo: async function (publicId) {
      const API =
        config.api +
        versionPrefix +
        apiService.getEmployeeEmployementInfo +
        `/${publicId}`;
      return fetchDataById(API, true, false);
    },

    getEmployeesStatsData: async function (details) {
      const API = config.api + versionPrefix + apiService.stats;
      return fetchData(API, details, true, false);
    },

    getNewEmployeeCountData: async function (details) {
      const API = config.api + versionPrefix + apiService.newEmployeeCount;
      return fetchData(API, details, true, false);
    },

    getEmployeesData: async function (details) {
      const API = config.api + versionPrefix + apiService.staff;
      return fetchData(API, details, true, true);
    },

    fetchEmployeePersonalInfo: async function (publicId) {
      const API =
        config.api + versionPrefix + apiService.getEmployeePersonalInfo;
      return fetchData(API, { publicId }, true, true);
    },

    updatePersonalInfo: async function (details, publicId, concurrencyStamp) {
      const API = config.api + versionPrefix + apiService.user + `/${publicId}`;
      return patchData(API, details, true, true, false, concurrencyStamp);
    },

    getPersonalInfoById: async function (publicId) {
      const API =
        config.api + versionPrefix + apiService.userById + `/${publicId}`;
      return fetchDataById(API, true, false);
    },

    getCurrentUserDetails: async function (details) {
      const API = config.api + versionPrefix + apiService.currentUserInfo;
      return fetchData(API, details, true, true);
    },

    updateIqamaInfo: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api + versionPrefix + apiService.iqamaInfo + `/${publicId}`;
      return patchData(API, details, true, true, false, concurrencyStamp);
    },

    fetchIqamaInfoById: async function (publicId) {
      const API =
        config.api + versionPrefix + apiService.iqamaInfo + `/${publicId}`;
      return fetchDataById(API, true, true);
    },

    updateEmploymentInfo: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api + versionPrefix + apiService.employmentInfo + `/${publicId}`;
      return patchData(API, details, true, true, false, concurrencyStamp);
    },

    updateSalaryDetails: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api + versionPrefix + apiService.salaryDetails + `/${publicId}`;
      return patchData(API, details, true, true, false, concurrencyStamp);
    },

    updateDepartmentMaster: async function (
      details,
      publicId,
      concurrencyStamp
    ) {
      console.log("concurrencyStamp: ", concurrencyStamp);
      const API =
        config.api + versionPrefix + apiService.getDepartment + `/${publicId}`;
      return patchData(API, details, true, false, false, concurrencyStamp);
    },

    fetchEmployeeSalaryDetails: async function (publicId) {
      const API =
        config.api + versionPrefix + apiService.getEmployeeSalaryDetails;
      return fetchData(API, publicId, true, false);
    },

    fetchEmployeeIqamaDetails: async function (publicId) {
      const API =
        config.api + versionPrefix + apiService.getEmployeeIqamaDetails;
      return fetchData(API, { publicId }, true, false);
    },

    fetchEmployeeAccountDetails: async function (publicId) {
      const API =
        config.api + versionPrefix + apiService.getEmployeeAccountDetails;
      return fetchData(API, { publicId }, true, false);
    },

    fetchAccountDetailsById: async function (publicId) {
      const API =
        config.api +
        versionPrefix +
        apiService.getEmployeeAccountDetails +
        `/${publicId}`;
      return fetchDataById(API, true, false);
    },

    updateAccountDetailsById: async function (
      details,
      publicId,
      concurrencyStamp
    ) {
      const API =
        config.api +
        versionPrefix +
        apiService.getEmployeeAccountDetails +
        `/${publicId}`;

      return patchData(API, details, true, true, false, concurrencyStamp);
    },

    fetchEmployeeHealthInsuranceDetails: async function (publicId) {
      const API =
        config.api +
        versionPrefix +
        apiService.getEmployeeHealthInsuranceDetails;
      return fetchData(API, { publicId }, true, false);
    },

    getInsuranceById: async function (publicId) {
      const API =
        config.api +
        versionPrefix +
        apiService.getEmployeeHealthInsuranceDetails +
        `/${publicId}`;
      return fetchDataById(API, true, false);
    },

    updateInsuranceInfo: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api +
        versionPrefix +
        apiService.getEmployeeHealthInsuranceDetails +
        `/${publicId}`;
      return patchData(API, details, true, true, false, concurrencyStamp);
    },

    fetchEmployeePassportDetails: async function (publicId) {
      const API =
        config.api + versionPrefix + apiService.getEmployeePassportDetails;
      return fetchData(API, { publicId }, true, false);
    },

    getPassportInfoById: async function (publicId) {
      const API =
        config.api +
        versionPrefix +
        apiService.getEmployeePassportDetails +
        `/${publicId}`;
      return fetchDataById(API, true, false);
    },

    updatePassportInfo: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api +
        versionPrefix +
        apiService.getEmployeePassportDetails +
        `/${publicId}`;
      return patchData(API, details, true, false, false, concurrencyStamp);
    },

    fetchEmployeeVisaDetails: async function (publicId) {
      const API =
        config.api + versionPrefix + apiService.getEmployeeVisaDetails;
      return fetchData(API, { publicId }, true, false);
    },

    updateVisaInfo: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api +
        versionPrefix +
        apiService.getEmployeeVisaDetails +
        `/${publicId}`;
      return patchData(API, details, true, false, false, concurrencyStamp);
    },

    fetchEmployeeContractDetails: async function (publicId) {
      const API =
        config.api + versionPrefix + apiService.getEmployeeContractDetails;
      return fetchData(API, { publicId }, true, false);
    },

    updateContractInfo: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api +
        versionPrefix +
        apiService.getEmployeeContractDetails +
        `/${publicId}`;
      return patchData(API, details, true, false, false, concurrencyStamp);
    },

    fetchEmployeeDrivingLicenseDetails: async function (publicId) {
      const API =
        config.api +
        versionPrefix +
        apiService.getEmployeeDrivingLicenseDetails;
      return fetchData(API, { publicId }, true, false);
    },
    deactivateEmployee: async function (details, publicId, concurrencyStamp) {
      const API = config.api + versionPrefix + apiService.user + `/${publicId}`;
      return deleteData(API, details, true, false, concurrencyStamp);
    },
    updateDrivingLicenseInfo: async function (
      details,
      publicId,
      concurrencyStamp
    ) {
      const API =
        config.api +
        versionPrefix +
        apiService.getEmployeeDrivingLicenseDetails +
        `/${publicId}`;
      return patchData(API, details, true, false, false, concurrencyStamp);
    },

    fetchEmployeeSubscriptionDetails: async function (publicId) {
      const API =
        config.api + versionPrefix + apiService.getEmployeeSubscriptionDetails;
      return fetchData(API, { publicId }, true, false);
    },

    updateSubscriptionInfo: async function (
      details,
      publicId,
      concurrencyStamp
    ) {
      const API =
        config.api +
        versionPrefix +
        apiService.getEmployeeSubscriptionDetails +
        `/${publicId}`;
      return patchData(API, details, true, false, false, concurrencyStamp);
    },

    fetchDependentsInfo: async function (publicId) {
      const API = config.api + versionPrefix + apiService.getDependentsInfo;
      return fetchData(API, { publicId }, true, false);
    },

    getDependentsInfoById: async function (publicId) {
      const API =
        config.api + versionPrefix + apiService.dependentsInfo + `/${publicId}`;
      return fetchDataById(API, true, false);
    },

    updateDependentsInfo: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api + versionPrefix + apiService.dependentsInfo + `/${publicId}`;
      return patchData(API, details, true, true, false, concurrencyStamp);
    },

    getExportReligionData: async function (details) {
      const API = config.api + versionPrefix + apiService.religionExport;
      return fetchData(API, details, true, false);
    },

    getReligionMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.getReligion;
      return fetchData(API, details, true, false);
    },

    addReligionData: async function (details) {
      const API = config.api + versionPrefix + apiService.getReligion;
      return postData(API, details, true, false);
    },

    updateReligionData: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api + versionPrefix + apiService.getReligion + `/${publicId}`;
      return patchData(API, details, true, false, false, concurrencyStamp);
    },

    changeReligionStatusData: async function (
      details,
      publicId,
      concurrencyStamp
    ) {
      const API =
        config.api + versionPrefix + apiService.getReligion + `/${publicId}`;
      return deleteData(API, details, true, true, concurrencyStamp);
    },

    getExportJobTitleData: async function (details) {
      const API = config.api + versionPrefix + apiService.jobTitleExport;
      return fetchData(API, details, true, false);
    },

    getJobTitleData: async function (details) {
      const API = config.api + versionPrefix + apiService.jobTitle;
      return fetchData(API, details, true, false);
    },

    addJobTitleData: async function (details) {
      const API = config.api + versionPrefix + apiService.jobTitle;
      return postData(API, details, true, false);
    },

    updateJobTitleData: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api + versionPrefix + apiService.jobTitle + `/${publicId}`;
      return patchData(API, details, true, false, false, concurrencyStamp);
    },

    changeJobTitleStatusData: async function (
      details,
      publicId,
      concurrencyStamp
    ) {
      const API =
        config.api + versionPrefix + apiService.jobTitle + `/${publicId}`;
      return deleteData(API, details, true, true, concurrencyStamp);
    },

    getExportJobGradeData: async function (details) {
      const API = config.api + versionPrefix + apiService.jobGradeExport;
      return fetchData(API, details, true, false);
    },

    getJobGradeData: async function (details) {
      const API = config.api + versionPrefix + apiService.jobGrade;
      return fetchData(API, details, true, false);
    },

    addJobGradeData: async function (details) {
      const API = config.api + versionPrefix + apiService.jobGrade;
      return postData(API, details, true, false);
    },

    updateJobGradeData: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api + versionPrefix + apiService.jobGrade + `/${publicId}`;
      return patchData(API, details, true, false, false, concurrencyStamp);
    },

    changeJobGradeStatusData: async function (
      details,
      publicId,
      concurrencyStamp
    ) {
      const API =
        config.api + versionPrefix + apiService.jobGrade + `/${publicId}`;
      return deleteData(API, details, true, true, concurrencyStamp);
    },

    getCountryMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.getCountry;
      return fetchData(API, details, false, false);
    },

    getStateMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.getState;
      return fetchData(API, details, false, false);
    },

    getNationalityMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.getNationality;
      return fetchData(API, details, true, false);
    },

    getDepartmentMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.getDepartment;
      return fetchData(API, details, true, false);
    },

    getDepartmentById: async function (publicId) {
      const API =
        config.api + versionPrefix + apiService.getDepartment + `/${publicId}`;
      return fetchDataById(API, true, true);
    },

    getDepartmentStatsData: async function (details) {
      const API = config.api + versionPrefix + apiService.departmentStats;
      return fetchData(API, details, true, false);
    },

    updateDepartmentMaster: async function (
      details,
      publicId,
      concurrencyStamp
    ) {
      const API =
        config.api + versionPrefix + apiService.getDepartment + `/${publicId}`;
      return patchData(API, details, true, false, false, concurrencyStamp);
    },

    deactivateDepartmentMaster: async function (
      details,
      publicId,
      concurrencyStamp
    ) {
      const API =
        config.api + versionPrefix + apiService.getDepartment + `/${publicId}`;
      return deleteData(API, details, true, false, concurrencyStamp);
    },

    getExportDepartmentData: async function (details) {
      const API = config.api + versionPrefix + apiService.departmentExport;
      return fetchData(API, details, true, false);
    },

    getExportDesignationData: async function (details) {
      const API = config.api + versionPrefix + apiService.designationExport;
      return fetchData(API, details, true, false);
    },

    getExportSecurityGroupData: async function (details) {
      const API = config.api + versionPrefix + apiService.securityGroupExport;
      return fetchData(API, details, true, false);
    },

    getExportRolesData: async function (details) {
      const API = config.api + versionPrefix + apiService.rolesExport;
      return fetchData(API, details, true, false);
    },

    getExportBranchesData: async function (details) {
      const API = config.api + versionPrefix + apiService.branchesExport;
      return fetchData(API, details, true, false);
    },

    getExportAuditTrailData: async function (details) {
      const API = config.api + versionPrefix + apiService.auditTrailExport;
      return fetchData(API, details, true, false);
    },

    getDesignationMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.getDesignation;
      return fetchData(API, details, true, false, false, false);
    },

    getDesignationById: async function (publicId) {
      const API =
        config.api + versionPrefix + apiService.getDesignation + `/${publicId}`;
      return fetchDataById(API, true, true);
    },

    getDesignationStatsData: async function (details) {
      const API = config.api + versionPrefix + apiService.designationStats;
      return fetchData(API, details, true, false);
    },

    deactivateDesignationMaster: async function (
      details,
      publicId,
      concurrencyStamp
    ) {
      const API =
        config.api + versionPrefix + apiService.getDesignation + `/${publicId}`;
      return deleteData(API, details, true, false, concurrencyStamp);
    },

    bulkStatusUpdate: async function (details) {
      const API = config.api + versionPrefix + apiService.bulkStatusUpdate;
      return patchData(API, details, true, false, false, false);
    },

    sendInvitation: async function (details) {
      const API = config.api + versionPrefix + apiService.employeeInvitation;
      return postData(API, details, true, false);
    },

    updateDesignationMaster: async function (
      details,
      publicId,
      concurrencyStamp
    ) {
      const API =
        config.api + versionPrefix + apiService.getDesignation + `/${publicId}`;
      return patchData(API, details, true, true, false, concurrencyStamp);
    },

    getSecurityGroupData: async function (details) {
      const API = config.api + versionPrefix + apiService.securityGroup;
      return fetchData(API, details, true, false);
    },

    getSecurityGroupStatsData: async function (details) {
      const API = config.api + versionPrefix + apiService.securityGroupStats;
      return fetchData(API, details, true, false);
    },

    getSecurityGroupByIdData: async function (publicId) {
      const API =
        config.api + versionPrefix + apiService.securityGroup + `/${publicId}`;
      return fetchDataById(API, true, true);
    },

    addSecurityGroupData: async function (details) {
      const API = config.api + versionPrefix + apiService.securityGroup;
      return postData(API, details, true, false);
    },

    updateSecurityGroupData: async function (
      details,
      publicId,
      concurrencyStamp
    ) {
      const API =
        config.api + versionPrefix + apiService.securityGroup + `/${publicId}`;
      return patchData(API, details, true, false, false, concurrencyStamp);
    },

    deleteSecurityGroup: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api + versionPrefix + apiService.securityGroup + `/${publicId}`;
      return deleteData(API, details, true, true, concurrencyStamp);
    },

    getPermissionData: async function (details) {
      const API = config.api + versionPrefix + apiService.permissionByAuth;
      return fetchData(API, details, true, false);
    },
    getSavedPermissionsData: async function (details) {
      const API =
        config.api +
        versionPrefix +
        apiService.securityGroupPermissions +
        "?pageSize=1000";
      return fetchData(API, details, true, false);
    },

    addPermissionsData: async function (details) {
      const API =
        config.api + versionPrefix + apiService.securityGroupPermissions;
      return postData(API, details, true, false);
    },

    updatePermissionsData: async function (
      details,
      publicId,
      concurrencyStamp
    ) {
      const API =
        config.api +
        versionPrefix +
        apiService.securityGroupPermissions +
        (publicId ? `/${publicId}` : "");
      return patchData(API, details, true, false, false, concurrencyStamp);
    },

    getEmployeesInfoMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.getEmployeeInfoMaster;
      return fetchData(API, details, true, false);
    },

    getEmployeesPersonalInfoMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.employees;
      return fetchData(API, details, true, false);
    },

    getEmployeeDepartmentById: async function (details, params) {
      const API =
        config.api + versionPrefix + apiService.getEmployeeDepartmentById;
      return fetchData(API, params, true, false);
    },

    deleteEmployeeMaster: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api + versionPrefix + apiService.deleteEmployee + `/${publicId}`;
      return deleteData(API, details, true, false, concurrencyStamp);
    },

    getExportEmployeeData: async function (details) {
      const API = config.api + versionPrefix + apiService.employeeExport;
      return fetchData(API, details, true, false);
    },

    getJobGradeMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.getJobGrade;
      return fetchData(API, details, false, false);
    },

    getContractTypeMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.getContactTypeMaster;
      return fetchData(API, details, true, false);
    },

    getProbationPeriodMaster: async function (details) {
      const API =
        config.api + versionPrefix + apiService.getProbationPeriodMaster;
      return fetchData(API, details, true, false);
    },

    getEmployementTypeMaster: async function (details) {
      const API =
        config.api + versionPrefix + apiService.getEmployementTypeMaster;
      return fetchData(API, details, true, false);
    },

    getBranchMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.branch;
      return fetchData(API, details, true, false);
    },

    addBranchData: async function (details) {
      const API = config.api + versionPrefix + apiService.branch;
      return postData(API, details, true, false);
    },

    getBranchStatsData: async function (details) {
      const API = config.api + versionPrefix + apiService.branchStats;
      return fetchData(API, details, true, false);
    },

    updateBranchData: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api + versionPrefix + apiService.branch + `/${publicId}`;
      return patchData(API, details, true, false, false, concurrencyStamp);
    },

    deactivateBranchData: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api + versionPrefix + apiService.branch + `/${publicId}`;
      return deleteData(API, details, true, true, concurrencyStamp);
    },

    getIqamaProfessionMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.getIqamaProfession;
      return fetchData(API, details, false, true);
    },

    getExportBankData: async function (details) {
      const API = config.api + versionPrefix + apiService.bankExport;
      return fetchData(API, details, true, false);
    },

    getBankMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.getBankMaster;
      return fetchData(API, details, true, false);
    },

    addBankData: async function (details) {
      const API = config.api + versionPrefix + apiService.getBankMaster;
      return postData(API, details, true, false);
    },

    changeBankStatusData: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api + versionPrefix + apiService.getBankMaster + `/${publicId}`;
      return deleteData(API, details, true, true, concurrencyStamp);
    },

    updateBankData: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api + versionPrefix + apiService.getBankMaster + `/${publicId}`;
      return patchData(API, details, true, false, false, concurrencyStamp);
    },

    getVisaTypeMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.getVisaTypeMaster;
      return fetchData(API, details, true, false);
    },

    getInsuranceClassMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.getInsuranceClass;
      return fetchData(API, details, true, false);
    },

    getRelationMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.getRelation;
      return fetchData(API, details, true, false);
    },
    addIqamaDocMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.iqamaDocMaster;
      return postData(API, details, true, false);
    },
    addDocumentsMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.addDocumentMaster;
      return postData(API, details, true, false, true);
    },
    addIqamaDocMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.iqamaDocMaster;
      return postData(API, details, true, false);
    },
    addDocumentsMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.addDocumentMaster;
      return postData(API, details, true, false, true);
    },

    getRolesMaster: async function (details) {
      const API = config.api + versionPrefix + apiService.getRoleMasters;
      return fetchData(API, details, true, false);
    },

    getRoleById: async function (publicId) {
      const API =
        config.api + versionPrefix + apiService.getRoleMasters + `/${publicId}`;
      return fetchDataById(API, true, true);
    },

    getAuditTrailData: async function (details) {
      const API = config.api + versionPrefix + apiService.auditTrail;
      return fetchData(API, details, true, false);
    },

    getStatus: async function (details, jobId) {
      const API =
        config.api + versionPrefix + apiService.getImportStatus + `/${jobId}`;
      return fetchData(API, details, true, false);
    },

    searchByFilter: async function (endpoint, filters) {
      const API = config.api + versionPrefix + endpoint;

      const details = {
        filters: filters || [],
      };

      try {
        const response = await fetchData(API, details, true, false);
        return response;
      } catch (error) {
        console.error("Search API Error:", error);
        throw error;
      }
    },

    //   updateEmployeeMaster: function (details, publicId, concurrencyStamp) {
    //     let API =
    //       config.api +
    //       versionPrefix +
    //       apiService.updateEmployeeMaster +
    //       "/" +
    //       publicId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "PATCH";
    //     return AxiosService({
    //       API,
    //       payload,
    //       authNeeded: true,
    //       type,
    //       concurrencyStamp,
    //     }).then((res) => {
    //       return res;
    //     });
    //   },

    //   deleteEmployeeMaster: function (details, publicId, concurrencyStamp) {
    //     let API =
    //       config.api +
    //       versionPrefix +
    //       apiService.deleteEmployeeMaster +
    //       "/" +
    //       publicId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "PATCH";
    //     return AxiosService({
    //       API,
    //       payload,
    //       authNeeded: true,
    //       type,
    //       concurrencyStamp,
    //     }).then((res) => {
    //       return res;
    //     });
    //   },

    //   //department
    //   getDepartmentMasters: function (details, token) {
    //     let API = config.api + versionPrefix + apiService.getDepartmentMasters;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    addDepartmentMasterData: async function (details) {
      const API = config.api + versionPrefix + apiService.addDepartmentMaster;
      return postData(API, details, true, false);
    },
    addDepartmentMaster: async function (details, token) {
      let API = config.api + versionPrefix + apiService.addDepartmentMaster;
      try {
        const response = await axios.post(API, details, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        // Handle the response as needed
        return response.data; // or return the entire response object if needed
      } catch (error) {
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem(config?.sessionKey);
          window.location.reload();
        }
        // Handle any errors that occur during the request
        console.error("Error adding access Designation:", error);
        throw error; // Re-throw the error if you want it to be handled by the caller
      }
    },
    //   updateDepartmentMaster: function (details, publicId, concurrencyStamp) {
    //     let API =
    //       config.api +
    //       versionPrefix +
    //       apiService.updateDepartmentMaster +
    //       "/" +
    //       publicId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "PATCH";
    //     return AxiosService({
    //       API,
    //       payload,
    //       authNeeded: true,
    //       type,
    //       concurrencyStamp,
    //     }).then((res) => {
    //       return res;
    //     });
    //   },
    //   deleteDepartmentMaster: function (details, publicId, concurrencyStamp) {
    //     let API =
    //       config.api +
    //       versionPrefix +
    //       apiService.deleteDepartmentMaster +
    //       "/" +
    //       publicId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "PATCH";
    //     return AxiosService({
    //       API,
    //       payload,
    //       authNeeded: true,
    //       type,
    //       concurrencyStamp,
    //     }).then((res) => {
    //       return res;
    //     });
    //   },
    // getByDepartmentById: function (details, publicId) {
    //   let API =
    //     config.api +
    //     versionPrefix +
    //     apiService.getByDepartmentById +
    //     "/" +
    //     publicId;
    //   let payload = {
    //     ...details,
    //   };
    //   let type = "GET";
    //   return AxiosService({
    //     API,
    //     payload,
    //     authNeeded: true,
    //     type,
    //   }).then((res) => {
    //     return res;
    //   });
    // },
    //   //designation
    //   getDesignationMasters: function (details, token) {
    //     let API = config.api + versionPrefix + apiService.getDesignationMasters;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },
    addDesignationMasterData: async function (details) {
      const API = config.api + versionPrefix + apiService.addDesignationMaster;
      return postData(API, details, true, false);
    },
    addDesignationMaster: async function (details, token) {
      let API = config.api + versionPrefix + apiService.addDesignationMaster;
      try {
        const response = await axios.post(API, details, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        // Handle the response as needed
        return response.data; // or return the entire response object if needed
      } catch (error) {
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem(config?.sessionKey);
          window.location.reload();
        }
        // Handle any errors that occur during the request
        console.error("Error adding access Designation:", error);
        throw error; // Re-throw the error if you want it to be handled by the caller
      }
    },
    //   updateDesignationMaster: function (details, publicId, concurrencyStamp) {
    //     let API =
    //       config.api +
    //       versionPrefix +
    //       apiService.updateDesignationMaster +
    //       "/" +
    //       publicId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "PATCH";
    //     return AxiosService({
    //       API,
    //       payload,
    //       authNeeded: true,
    //       type,
    //       concurrencyStamp,
    //     }).then((res) => {
    //       return res;
    //     });
    //   },
    //   deleteDesignationMaster: function (details, publicId, concurrencyStamp) {
    //     let API =
    //       config.api +
    //       versionPrefix +
    //       apiService.deleteDesignationMaster +
    //       "/" +
    //       publicId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "PATCH";
    //     return AxiosService({
    //       API,
    //       payload,
    //       authNeeded: true,
    //       type,
    //       concurrencyStamp,
    //     }).then((res) => {
    //       return res;
    //     });
    //   },
    //   getDesignationById: function (details, publicId) {
    //     let API =
    //       config.api +
    //       versionPrefix +
    //       apiService.getDesignationById +
    //       "/" +
    //       publicId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({
    //       API,
    //       payload,
    //       authNeeded: true,
    //       type,
    //     }).then((res) => {
    //       return res;
    //     });
    //   },
    //   //role apis
    //   //designation
    //   getRoleMasters: function (details, token) {
    //     let API = config.api + versionPrefix + apiService.getRoleMasters;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },
    //   deleteRole: function (details, token) {
    //     let API = config.api + versionPrefix + apiService.getRoleMasters;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "PATCH";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },
    addAccessRole: async function (details, token) {
      const API = config.api + versionPrefix + apiService.addAccessRole;
      const payload = {
        roleCode: details.roleId,
        role: details.roleName,
        description: details.description,
      };

      try {
        const response = await axios.post(API, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        // Handle the response as needed
        return response.data; // or return the entire response object if needed
      } catch (error) {
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem(config?.sessionKey);
          window.location.reload();
        }
        // Handle any errors that occur during the request
        console.error("Error adding access role:", error);
        throw error; // Re-throw the error if you want it to be handled by the caller
      }
    },
    updateAccessRole: async function (
      details,
      token,
      publicId,
      concurrencyStamp
    ) {
      const API = `${config.api}${versionPrefix}${apiService.addAccessRole}/${publicId}`;
      const payload = {
        roleCode: details.roleId,
        role: details.roleName,
        description: details.description,
      };

      try {
        const response = await axios.patch(API, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "x-coreplatform-concurrencystamp": concurrencyStamp,
          },
        });

        // Handle the response as needed
        return response.data; // or return the entire response object if needed
      } catch (error) {
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem(config?.sessionKey);
          window.location.reload();
        }
        // Handle any errors that occur during the request
        console.error("Error adding access role:", error);
        throw error; // Re-throw the error if you want it to be handled by the caller
      }
    },
    deleteAccessRole: async function (details, publicId, concurrencyStamp) {
      const API =
        config.api + versionPrefix + apiService.addAccessRole + `/${publicId}`;
      return deleteData(API, details, true, false, concurrencyStamp);
    },
    getRoleStatsData: async function (details) {
      const API = config.api + versionPrefix + apiService.roleStats;
      return fetchData(API, details, true, false);
    },

    // Analytical Dashboard
    getEmpMonthlyData: async function (details) {
      const API = config.api + versionPrefix + apiService.analyticsBaseRoute + apiService.getEmpMonthlyData;
      return fetchData(API, details, true, false);
    },
    getIqamaStatusData: async function (details) {
      const API = config.api + versionPrefix + apiService.analyticsBaseRoute + apiService.getIqamaStatusData;
      return fetchData(API, details, true, false);
    },
    getEmpDeptStatsData: async function (details) {
      const API = config.api + versionPrefix + apiService.analyticsBaseRoute + apiService.getEmpDeptStatsData;
      return fetchData(API, details, true, false);
    },
    getEmpDesgStatsData: async function (details) {
      const API = config.api + versionPrefix + apiService.analyticsBaseRoute + apiService.getEmpDesgStatsData;
      return fetchData(API, details, true, false);
    },

    //   // branch
    //   getBranch: function (details, token) {
    //     let API = config.api + versionPrefix + apiService.getBranch;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },

    //   addBranch: function (details, token) {
    //     let API = config.api + versionPrefix + apiService.addBranch;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "POST";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },
    //   emailTemplate: function (details, token) {
    //     let API = config.crmApi + versionPrefix + apiService.emailTemplate;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "POST";
    //     return AxiosService({ API, payload, authNeeded: true, type, token }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },
    //   addEmailTemplate: function (details) {
    //     let API = config.crmApi + versionPrefix + apiService.emailTemplate;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "POST";
    //     return AxiosService({ API, payload, authNeeded: true, type }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },
    //   updateEmailTemplate: function (details, publicId, concurrencyStamp) {
    //     let API =
    //       config.crmApi +
    //       versionPrefix +
    //       apiService.emailTemplate +
    //       "/" +
    //       publicId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "PATCH";
    //     return AxiosService({
    //       API,
    //       payload,
    //       authNeeded: true,
    //       type,
    //       concurrencyStamp,
    //     }).then((res) => {
    //       return res;
    //     });
    //   },
    //   getEmailTemplate: function (details) {
    //     let API = config.crmApi + versionPrefix + apiService.emailTemplate;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },
    //   getEmailTemplateById: function (details, publicId) {
    //     let API =
    //       config.crmApi +
    //       versionPrefix +
    //       apiService.emailTemplate +
    //       "/" +
    //       publicId;
    //     let payload = {
    //       ...details,
    //     };
    //     let type = "GET";
    //     return AxiosService({ API, payload, authNeeded: true, type }).then(
    //       (res) => {
    //         return res;
    //       }
    //     );
    //   },
    getUmsAuthProvider: async function (details) {
      const API = config.api + versionPrefix + apiService.authUmsProvider;
      return fetchData(API, details, true, false);
    },
    groupPermissionsByAuthProvider: async function (details) {
      const API =
        config.api + versionPrefix + apiService.groupPermissionsByAuthProvider;
      return fetchData(API, details, true, false);
    },
    getRolePermissions: async function (details) {
      const API =
        config.api +
        versionPrefix +
        apiService.getRolePermisson +
        "?pageSize=10000";
      return fetchData(API, details, true, false);
    },
    postRolePermissions: async function (
      details,
      token,
      method,
      publicId,
      concurrencyStamp
    ) {
      const API = config.api + versionPrefix + apiService.getRolePermisson;
      const payload = {
        ...details,
      };

      try {
        let response;
        if (method == "post") {
          response = await axios.post(API, payload, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });
        } else {
          response = await axios.patch(API, payload, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
              "x-coreplatform-concurrencystamp": concurrencyStamp,
            },
          });
        }

        // Handle the response as needed
        return response.data; // or return the entire response object if needed
      } catch (error) {
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem(config?.sessionKey);
          window.location.reload();
        }
        // Handle any errors that occur during the request
        console.error("Error adding access role:", error);
        throw error; // Re-throw the error if you want it to be handled by the caller
      }
    },
  };

  return Services;
}
